export default class GlobalSearchBox extends Backbone.View
  events:
    "submit" : "onSearchSubmit"

  initialize: (options) ->
    @$query = @$el.find(".query")

  onSearchSubmit: (event) ->
    event.preventDefault() if (@$query.val().length == 0)



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/global_search_box.js.coffee